/**
=========================================================
* Argon Dashboard 2 PRO MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-mui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Argon Dashboard 2 PRO MUI components
import ArgonTypography from "components/ArgonTypography";

const categoriesListData = [
  {
    color: "dark",
    icon: "devices_other",
    name: "Crea un post",
    description: <>Crea un post con AI e pubblicalo.</>,
    route: "/cms/social",
  },
  {
    color: "dark",
    icon: "message",
    name: "Messaggi e Direct",
    description: <>Tieni sotto controllo tutti i messaggi.</>,
    route: "/crm/answer",
  },
  {
    color: "dark",
    icon: "settings",
    name: "Lead da gestire",
    description: <>Accedi alla lista dei lead ricevuti.</>,
    route: "/crm/todo",
  },
];

export default categoriesListData;
